import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchSensorInfo } from "../../../api/sensorApi";

function useGetLiveModelScores(sensorId, currTab, list) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (sensorId && currTab === "scores") {
            setLoading(true);
            fetchSensorInfo(sensorId).then((res) => {
                if (res) {
                    res = res[0];
                    const scores = {
                        mse: res.latestMseScore,
                        mseWT: res.latestMSEWTScore,
                        r2: res.latestR2Score,
                        r2WT: res.latestR2WTScore,
                        rating: res.sensorRating,
                    };
                    setData(scores);
                } else {
                    setData(null);
                }
            })
            .catch((error) => {
                console.error(error);
                toast.error("Error fetching live model data")
                setData(null);
            })
            .finally(() => setLoading(false));
        }

    }, [sensorId, currTab, list]);
    return { data, loading };
}

export default useGetLiveModelScores;